import { BCMOsisRuleListItem } from '../../../integrated-client/models';

export type RuleListItemsList = Array<BCMOsisRuleListItem>;
export class ResultsData {

  ruleList: RuleListItemsList
  showMore: boolean

  constructor() {
    this.ruleList = [];
    this.showMore = false;
  }

}